<p align="middle">Version: {{version}}</p>
<p align="middle">Commit: {{commitHash}}</p>
